import { BoxProps } from 'ui/Layout';
import Link from 'ui/Link';
import { Text } from 'ui/Typography';

import { websiteLinkTo } from '../../utils/routes';

const SignUpTermsAndPrivacy: React.FC<BoxProps> = (props) => (
  <Text fontSize="xs" textAlign="center" {...props}>
    * By continuing you accept our{' '}
    <Link href={websiteLinkTo('/terms/')} isExternal>
      terms of use
    </Link>{' '}
    and{' '}
    <Link href={websiteLinkTo('/privacy/')} isExternal>
      privacy policy
    </Link>
  </Text>
);

export default SignUpTermsAndPrivacy;
